module.exports = __webpack_public_path__ + "img/gc_country_flag_null.2c29083e.svg";